export enum Status {
    Funded = 'Funded',
    DocsBack = 'Docs Back',
    ReadyForSale = 'Ready For Sale',
    LoanShipped = 'Loan Shipped',
    LoanSold = 'Loan Sold',
    ClearToClose = 'Clear to Close',
    Recorded = 'Recorded',
    DocsOut = 'Docs Out',
    LoanCanceled = 'Loan Canceled',
    FinalUnderwriting = 'Final Underwriting',
    LoanOpen = 'Loan Open',
    DocsOrdered = 'Docs Ordered',
    Sold = 'Sold',
    DocsDrawn = 'Docs Drawn',
    PreApproved = 'Pre-approved',
    PreQual = 'Pre-qual',
    FinalDocs = 'Final Docs'
}